module.exports = __webpack_public_path__ + "static/media/04A.8eacea8e.png";